import { defineNuxtRouteMiddleware } from '#app';
import { MindboxService } from '../services';
import type { IMindboxAddProductToBucketQuery, IMindboxOpenPageQuery } from '../services';

const bucketUrls = [
  '/consultant-plus/poluchit-polnyj-prajs-na-2025',
  '/consultant-plus/probnyj-dostup-besplatno',
  '/consultant-plus/demonstraciya-konsultantplyus',
  '/consultant-plus/poluchite-dostup-k-praktikumu',
  '/consultant-plus/dostup-k-novshestvu-konsultantplyus',
];

const pageUrls = [
  '/consultant-plus',
  '/consultant-plus/buhgalteru',
  '/consultant-plus/uristu',
  '/consultant-plus/rukovoditelu',
  '/consultant-plus/specialist-po-zakupkam',
  '/consultant-plus/kadroviku',
  '/consultant-plus/big-test-drive',
  '/consultant-plus/special-price_v2',
  '/consultant-plus/praktikumy/sekrety-uspeshnogo-uvolneniya',
  '/consultant-plus/praktikumy/polugodovaya-otchetnost-2025-sdaem-bez-oshibok-i-shtrafov',
  '/consultant-plus/praktikumy/dogovornye-lovushki-kak-izbezhat-riskov-i-neudach',
  '/consultant-plus/praktikumy/kak-izbezhat-shtrafov-za-persdannye-reklamu-i-massovye-zvonki',
  '/consultant-plus/praktikumy/kameralnye-proverki-kak-nalogovaya-proverit-vashu-otchetnost',
  '/consultant-plus/praktikumy/rabota-s-migrantami-po-novym-pravilam',
  '/consultant-plus/praktikumy/kvartalnaya-otchetnost',
  '/consultant-plus/praktikumy/nalogovaya-bezopasnost-proverte-svoj-biznes',
  '/consultant-plus/praktikumy/kak-nalogovaya-reforma-otrazitsya-na-vashem-biznese',
  '/consultant-plus/novshestva-konsultantplyus/tandem-dlya-pobedy-v-sude',
];

const sendAddProductToBucket = async (toUrl: string, fromUrl: string) => {
  const mindboxService = new MindboxService();

  const config = useRuntimeConfig();

  const productId = 'www.4dk.ru' + toUrl.replaceAll('/', '--');
  const fromPath = config.public.siteUrl + fromUrl;

  const query: IMindboxAddProductToBucketQuery = {
    addProductToList: {
      customFields: {
        buttonFrom: fromPath,
      },
      product: {
        ids: {
          website: productId,
        },
      },
    },

  };

  try {
    await mindboxService.addProductToBucket(query);
  }
  catch (error) {
    console.log('ERROR in sendAddProductToBucket :', error);
  }
};

const sendOpenPage = async (toUrl: string) => {
  const mindboxService = new MindboxService();

  const productId = 'www.4dk.ru' + toUrl.replaceAll('/', '--');

  const query: IMindboxOpenPageQuery = {
    viewProduct: {
      product: {
        ids: {
          website: productId,
        },
      },
    },

  };

  try {
    await mindboxService.openPage(query);
  }
  catch (error) {
    console.log('ERROR in sendOpenPage :', error);
  }
};

export default defineNuxtRouteMiddleware((to, from) => {
  if (import.meta.client) {
    if (bucketUrls.includes(to.path)) {
      sendAddProductToBucket(to.fullPath, from.fullPath);
    }

    if (pageUrls.includes(to.path)) {
      sendOpenPage(to.fullPath);
    }
  }
});
